import { SPACES } from 'common/constants/sizes';
import { Flex } from 'components/base/layout-components';
import Text from 'components/base/Text';
import smellTheFlowers from 'images/smell-the-flowers.svg';

const EmptyState = () => {
  return (
    <Flex
      pt='big'
      pb='x-large'
      direction='column'
      width='100%'
      items='center'
      justify='center'
    >
      <img src={smellTheFlowers} alt='' />
      <Text weight='500' size='large' pt={SPACES.normal} pb={SPACES['x-small']}>
        No messages
      </Text>
      <Text size='medium' color='shuttleGray'>
        Enjoy the breeze, smell the flowers
      </Text>
    </Flex>
  );
};

export default EmptyState;
